import React, { ReactElement } from 'react';
import { Banner } from 'b2b-apps/shop/product/components/ProductDetails/ProductDescription/Banner';
import { BulletPoints } from 'b2b-apps/shop/product/components/ProductDetails/ProductDescription/BulletPoints';
import { DangerDetails } from 'b2b-apps/shop/product/components/ProductDetails/ProductDescription/DangerDetails';
import { DangerIcons } from 'b2b-apps/shop/product/components/ProductDetails/ProductDescription/DangerIcons';
import { Remark } from 'b2b-apps/shop/product/components/ProductDetails/ProductDescription/Remark';
import { TranslationInfo } from 'b2b-apps/shop/product/components/ProductDetails/ProductDescription/TranslationInfo';
import { getCdnImageUrl } from 'b2b-apps/shop/routes/utils/url';
import { ComponentType, Props } from './';
import './ProductDescription.scss';

const ProductDescription: ComponentType = ({
  description: {
    banners,
    dangerDetails,
    dangerIcons,
    descriptionBulletPoints: bulletPoints,
    isTranslatedByDeepl,
    lead,
    paragraphs,
    remarks,
    subtitle,
    title,
  },
}: Props): ReactElement => (
  <div className="ProductDescription">
    {Array.isArray(dangerIcons) && dangerIcons.length > 0 && (
      <DangerIcons dangerIcons={dangerIcons} />
    )}

    {title && <h2 className="ProductDescription-Title">{title}</h2>}

    {subtitle && <h3 className="ProductDescription-Subtitle">{subtitle}</h3>}

    {Array.isArray(dangerDetails) && dangerDetails.length > 0 && (
      <DangerDetails dangerDetails={dangerDetails} />
    )}

    {Array.isArray(bulletPoints) && bulletPoints.length > 0 && (
      <BulletPoints bulletPoints={bulletPoints} />
    )}

    {lead && <p className="ProductDescription-Lead">{lead}</p>}

    {paragraphs.map((paragraph, key) => (
      <div className="ProductDescription-Paragraph" key={key}>
        <h4 className="ProductDescription-ParagraphTitle">{paragraph.title}</h4>

        <p>{paragraph.text}</p>
      </div>
    ))}

    {isTranslatedByDeepl && <TranslationInfo />}

    {banners.map((banner, key) => {
      const imageUrl = getCdnImageUrl(banner.image);
      return (
        imageUrl && <Banner image={imageUrl} key={key} url={banner.href} />
      );
    })}

    {remarks.map((remark, key) => (
      <Remark content={remark.text} key={key} />
    ))}
  </div>
);

export { ProductDescription };
